export enum PrivilegeSearchFields {
	searchByCode = 'searchByCode',
	searchByName = 'searchByName',
	searchByRoleName = 'searchByRoleName'
}

export declare namespace Privilege {
	interface Basic {
		id: number
		name: string
		code: string
		roleNames: string[]
		createDate: string
		lastUpdated: string
	}

	interface BasicFromId extends Pick<Basic, 'code' | 'name' | 'id'> {
		assignedRoles: Entity[]
	}

	namespace Form {
		type AddPrivilege = Pick<Basic, 'code' | 'name'>
	}

	namespace Search {
		interface Result {
			[PrivilegeSearchFields.searchByCode]: (Entity & { code: string })[]
			[PrivilegeSearchFields.searchByName]: Entity[]
			[PrivilegeSearchFields.searchByRoleName]: (Entity & { roleName: string })[]
		}
	}
}
